<template>
  <div class="after-sale-list">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <!-- <el-tab-pane :label="`${$t(`page.users.afterSale.tabs.apply`)}(${applyCount})`" name="first"></el-tab-pane> -->
      <el-tab-pane :label="`${$t(`page.users.afterSale.tabs.processing`)}(${processingCount})`" name="1"></el-tab-pane>
      <el-tab-pane :label="`${$t(`page.users.afterSale.tabs.completed`)}(${completedCount})`" name="2"></el-tab-pane>
    </el-tabs>

    <div class="list-container" v-loading="loading">
      
      <!-- 详情页视图 -->
      <div v-if="viewType === 'detail'" class="detail-container">
          <div class="detail-header">
              <span class="title">{{ $t(`page.users.afterSaleDetail.returnType`) }}</span>
              <span class="status red">{{ detailData.applyStatus }}</span>
          </div>
          
          <div class="address-info">
              <div class="row">
                  <span class="label">{{ $t(`page.users.afterSaleDetail.consignee`) }}：</span>
                  <span class="value">{{ detailData.address_name }}</span>
              </div>
              <div class="row">
                  <span class="label">{{ $t(`page.users.afterSaleDetail.contact`) }}：</span>
                  <span class="value">{{ detailData.address_mobile }}</span>
              </div>
              <div class="row">
                  <span class="label">{{ $t(`page.users.afterSaleDetail.returnAddress`) }}：</span>
                  <span class="value">{{ detailData.express_address }}</span>
                  <span class="copy-btn">{{ $t(`page.users.afterSaleDetail.copy`) }}</span>
              </div>
          </div>
          
          <div class="refund-info-bar">
              <span class="mr-40">{{ $t(`page.users.afterSale.labels.applyTime`) }}：{{ detailData.applyTime }}</span>
              <span>{{ $t(`page.users.afterSaleDetail.refundSn`) }}：{{ detailData.order_no }}</span>
          </div>
          
          <div class="detail-table">
              <div class="table-header">
                  <div class="col-info">{{ $t(`page.users.afterSaleDetail.table.info`) }}</div>
                  <div class="col-qty">{{ $t(`page.users.afterSaleDetail.table.quantity`) }}</div>
                  <div class="col-amount">{{ $t(`page.users.afterSaleDetail.table.amount`) }}</div>
                  <div class="col-reason">{{ $t(`page.users.afterSaleDetail.table.reason`) }}</div>
              </div>
              <div class="table-body">
                   <div class="col-info">
                      <img :src="detailData.productImage" alt="" class="product-image">
                      <div class="info-text">
                        <div class="product-name line2">{{ detailData.productName }}</div>
                        <div class="sku-name">{{ detailData.sku }}</div>
                      </div>
                   </div>
                   <div class="col-qty">{{ detailData.quantity }}</div>
                   <div class="col-amount">¥{{ detailData.price }}</div>
                   <div class="col-reason">{{ detailData.reason }}</div>
              </div>
          </div>
          
          <div class="detail-actions" v-if="activeName === '1'">
               <div class="action-btn outline" @click="cancelApply(detailData)">{{ $t(`page.users.afterSale.buttons.cancel`) }}</div>
               <div class="action-btn outline ml-10" @click="fillTracking(detailData)">{{ $t(`page.users.afterSale.buttons.fillTracking`) }}</div>
          </div>
      </div>

      <!-- 列表视图 -->
      <div v-else class="list-view">
        <!-- 售后申请列表 -->
        <template v-if="activeName === 'first'">
            <div class="sale-item" v-for="(item, index) in tableData" :key="index">
            <div class="item-body">
                <div class="col-info" @click="goDetail(item)">
                    <img :src="item.productImage" alt="" class="product-image">
                    <div class="info-text">
                        <div class="product-name line2">{{ item.productName }}</div>
                        <div class="price">¥{{ item.price }} x {{ item.quantity }}</div>
                    </div>
                </div>
                <div class="col-actions">
                <div class="action-btn" @click="applyAfterSale(item)">{{ $t(`page.users.afterSale.buttons.apply`) }}</div>
                </div>
            </div>
            </div>
        </template>

        <!-- 处理中列表 -->
        <template v-if="activeName === '1'">
            <div class="sale-item" v-for="(item, index) in tableData" :key="index">
            <div class="item-header">
                <span class="mr-20">{{ $t(`page.users.afterSale.labels.applyTime`) }}：{{ item.applyTime }}</span>
                <span>{{ $t(`page.users.afterSale.labels.applyStatus`) }}：{{ item.applyStatus }}</span>
                <span class="status-tag red">{{ item.refundType }}</span>
            </div>
            <div class="item-body">
                <div class="col-info">
                <img :src="item.productImage" alt="" class="product-image">
                <div class="info-text">
                    <div class="product-name line2">{{ item.productName }}</div>
                    <div class="price">¥{{ item.price }} x {{ item.quantity }}</div>
                </div>
                </div>
                <div class="col-actions">
                <div class="btn-group">
                    <div class="action-btn outline" @click="viewDetails(item)">{{ $t(`page.users.afterSale.buttons.view`) }}</div>
                    <div class="action-btn outline" @click="cancelApply(item)">{{ $t(`page.users.afterSale.buttons.cancel`) }}</div>
                </div>
                <div v-if="item.showTracking" class="action-btn outline mt-10" @click="fillTracking(item)">{{ $t(`page.users.afterSale.buttons.fillTracking`) }}</div>
                </div>
            </div>
            </div>
        </template>
        
        <!-- 已处理列表 -->
        <template v-if="activeName === '2'">
            <div class="sale-item" v-for="(item, index) in tableData" :key="index">
            <div class="item-header">
                <span class="mr-20">{{ $t(`page.users.afterSale.labels.applyTime`) }}：{{ item.applyTime }}</span>
                <span>{{ $t(`page.users.afterSale.labels.applyStatus`) }}：{{ item.applyStatus }}</span>
                <span class="status-tag red">{{ item.refundType }}</span>
            </div>
            <div class="item-body">
                <div class="col-info">
                <img :src="item.productImage" alt="" class="product-image">
                <div class="info-text">
                    <div class="product-name line2">{{ item.productName }}</div>
                    <div class="price">¥{{ item.price }} x {{ item.quantity }}</div>
                </div>
                </div>
                <div class="col-actions">
                <div class="action-btn outline" @click="viewDetails(item)">{{ $t(`page.users.afterSale.buttons.view`) }}</div>
                </div>
            </div>
            </div>
        </template>

        <div class="empty-box" v-if="tableData.length == 0 && !loading">
            <img src="@/assets/images/noorder.png" alt="">
            <p>{{$t(`page.users.orderList.empty`)}}~</p>
        </div>
      </div>
    </div>
    
     <div class="pagination-container" v-if="total > 0 && viewType === 'list'">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="10"
        layout="prev, pager, next"
        :total="total"
        background
      >
      </el-pagination>
    </div>

    <!-- 填写快递单号弹窗 -->
    <trackingDialog 
      :visible.sync="trackingDialogVisible" 
      :refundId="currentRefundId"
      @success="handleTrackingSuccess"
    />
  </div>
</template>

<script>
import trackingDialog from '@/components/trackingDialog'
import Cookies from 'js-cookie';
export default {
  name: 'AfterSale',
  components: {
    trackingDialog
  },
  data() {
    return {
      activeName: '1',
      applyCount: 2,
      processingCount: 0,
      completedCount: 0,
      tableData: [],
      loading: false,
      currentPage: 1,
      total: 0,
      viewType: 'list', // 'list' or 'detail'
      detailData: {},
      trackingDialogVisible: false,
      currentRefundId: ''
    };
  },
  mounted() {
    // 从路由参数获取 activeName
    const activeName = this.$route.query.activeName;
    if (activeName) {
      this.activeName = activeName;
    }
    this.getList();
  },
  methods: {
    handleClick(tab, event) {
      this.currentPage = 1;
      this.viewType = 'list';
      this.getList();
    },
    getList() {
      if (this.viewType === 'detail') return;
      this.loading = true;
      const data = {
          status: this.activeName, 
          page: this.currentPage,
          pageSize: 10
      }
      this.$axios.get('/api/center/getRefundlist', { params: data }).then(res => {
          // 新数据格式: { id, status, addtime, order_sub_id, type, sub[], status_text }
          let lang = Cookies.get('locale')
          this.tableData = res.data.list.map(item => {
              // 从 sub 数组中获取第一个商品信息
              const product = item.sub && item.sub[0] ? item.sub[0] : {};
              return {
                  id: item.id,
                  order_sub_id: item.order_sub_id,
                  status: item.status,  // 0 申请中， 1 已同意 2 已拒绝
                  productImage: product.img || '',
                  productName: product.name || '',
                  price: product.price || 0,
                  quantity: product.num || 0,
                  weight: product.weight,
                  express_address: item.express_address,
                  address_mobile: item.address_mobile,
                  address_name: item.address_name,
                  applyTime: item.addtime,
                  reason: item.reason,
                  order_no: item.order_no,
                  applyStatus: lang == 1 ? item.status_text : item.es_status_text,
                  refundType: item.type == 1 ? this.$t('page.users.goodsReturn.type1') : this.$t('page.users.goodsReturn.type2'),
                  showTracking: item.type == 2 && item.status == 0 // 退货退款且申请中时显示填写快递单号
              };
              
          });
          console.log(this.tableData, 'detailData')
          this.total = res.data.total; // 如果后端返回 total 字段，使用 res.data.total
          this.processingCount = res.data.count2;
          this.completedCount = res.data.count3;
          this.loading = false;
      }).catch(err => {
        console.log(err)
          this.loading = false;
      });
    },
    handleCurrentChange(val) {
        this.currentPage = val;
        this.getList();
    },
    applyAfterSale(item) {
        console.log('Apply after sale for:', item);
    },
    viewDetails(item) {
        this.detailData = item;
        this.viewType = 'detail';
    },
    // 撤销申请
    cancelApply(item) {
        this.$confirm(
            this.$t('page.users.afterSale.confirmCancel'),
            this.$t('message.tips.tips'),
            {
                confirmButtonText: this.$t('page.goodsDetail.confirm'),
                cancelButtonText: this.$t('page.goodsDetail.cancel'),
                type: 'warning'
            }
        ).then(() => {
            this.$axios.post('/api/center/cancelRefund', {
                id: item.id
            }).then(res => {
                this.$message.success(this.$t('page.users.afterSale.cancelSuccess'))
                this.getList()
            }).catch(err => {
                this.$message.error(err.message || this.$t('page.users.afterSale.cancelFailed'))
            })
        }).catch(() => {
            // 用户取消操作
        })
    },
    fillTracking(item) {
        this.currentRefundId = item.id;
        this.trackingDialogVisible = true;
    },
    handleTrackingSuccess() {
        this.$message.success(this.$t('page.users.trackingDialog.submitSuccess'));
        this.getList();
    },
  }
};
</script>

<style lang="scss" scoped>
.after-sale-list {
  padding: 20px;
  background-color: #fff;

  .list-container {
      margin-top: 20px;
  }
  
  // Detail View Styles
  .detail-container {
      .detail-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-bottom: 20px;
          border-bottom: 1px solid #EAEAEA;
          .title { font-size: 16px; font-weight: bold; color: #333; }
          .status { font-size: 14px; &.red { color: #E93323; } }
      }
      
      .address-info {
          padding: 20px 0;
          .row {
              margin-bottom: 10px;
              font-size: 14px;
              color: #333;
              display: flex;
              align-items: center;
              .label { width: 80px; color: #666; }
              .copy-btn {
                  margin-left: 15px;
                  background-color: #FFEFEF;
                  color: #E93323;
                  padding: 2px 8px;
                  font-size: 12px;
                  border-radius: 2px;
                  cursor: pointer;
              }
          }
      }
      
      .refund-info-bar {
          background-color: #F7F7F7;
          padding: 15px 20px;
          font-size: 13px;
          color: #666;
          margin-bottom: 20px;
          .mr-40 { margin-right: 40px; }
      }
      
      .detail-table {
          border: 1px solid #EAEAEA;
          margin-bottom: 20px;
          
          .table-header {
              display: flex;
              background-color: #FAFAFA;
              padding: 10px 20px;
              font-weight: bold;
              font-size: 13px;
              color: #333;
              border-bottom: 1px solid #EAEAEA;
          }
          
          .table-body {
              display: flex;
              align-items: center;
              padding: 20px;
              font-size: 14px;
              color: #333;
          }
          
          .col-info { flex: 3; display: flex; align-items: center; 
             .product-image { width: 60px; height: 60px; margin-right: 15px; border-radius: 4px; }
             .info-text {
                 .product-name { margin-bottom: 5px; }
                 .sku-name { color: #999; font-size: 12px; }
             }
          }
          .col-qty { flex: 1; text-align: center; }
          .col-amount { flex: 1; text-align: center; font-weight: bold; }
          .col-reason { flex: 2; text-align: center; color: #666; }
      }
      
      .detail-actions {
          display: flex;
          justify-content: flex-end;
          margin-top: 20px;
          .action-btn {
              padding: 8px 20px;
              border: 1px solid #DCDFE6;
              color: #606266;
              border-radius: 3px;
              font-size: 14px;
              cursor: pointer;
              background: #fff;
              &:hover { border-color: #E93323; color: #E93323; }
              &.ml-10 { margin-left: 10px; }
          }
      }
  }

  .sale-item {
      border: 1px solid #EBEEF5;
      margin-bottom: 20px;
      &:last-child { margin-bottom: 0; }
      
      .item-header {
          background-color: #F7F7F7;
          padding: 10px 20px;
          color: #666;
          font-size: 13px;
          display: flex;
          align-items: center;
          
          .mr-20 { margin-right: 40px; }
          .status-tag {
              margin-left: auto;
              &.red { color: #E93323; }
          }
      }
      
      .item-body {
          display: flex;
          align-items: center;
          padding: 20px;
          
          .col-info {
              flex: 1;
              display: flex;
              align-items: center;
              
              .product-image {
                  width: 80px;
                  height: 80px;
                  margin-right: 15px;
                  border-radius: 4px;
              }
              
              .info-text {
                  flex: 1;
                  padding-right: 20px;
                  
                  .product-name {
                      color: #333;
                      font-size: 14px;
                      line-height: 1.5;
                      margin-bottom: 5px;
                  }
                  .sku-name {
                      color: #999;
                      font-size: 12px;
                      margin-bottom: 5px;
                  }
                  .price {
                      color: #E93323;
                      font-size: 14px;
                      font-weight: bold;
                  }
              }
          }
          
          .col-actions {
              width: 180px;
              display: flex;
              flex-direction: column;
              align-items: flex-end;
              justify-content: center;
              
              .btn-group {
                  display: flex;
                  gap: 10px;
              }
              
              .action-btn {
                  padding: 6px 15px;
                  border: 1px solid #E93323; // Default style for "Apply" (申请售后) is slightly different in image? Actually looks outline gray. Let's recheck.
                  // Checking image 1: 申请售后 button has border.
                  // Checking image 2: 查看详情/撤销申请/填写快递单号 buttons have border.
                  border: 1px solid #DCDFE6;
                  color: #606266;
                  border-radius: 3px;
                  font-size: 12px;
                  cursor: pointer;
                  text-align: center;
                  background: #fff;
                  
                  &:hover {
                      border-color: #E93323;
                      color: #E93323;
                  }
              }
              
              .mt-10 { margin-top: 10px; }
          }
      }
  }

  .pagination-container {
    margin-top: 30px;
    text-align: right;
  }
  
  .empty-box {
      text-align: center;
      padding: 50px 0;
      img { width: 150px; }
      p { color: #999; margin-top: 20px; }
  }

  ::v-deep .el-tabs__item.is-active {
    color: #E93323;
  }
  ::v-deep .el-tabs__active-bar {
      background-color: #E93323;
  }
  ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #E93323;
  }
}
</style>